import { render, staticRenderFns } from "./znpcYz.vue?vue&type=template&id=2ec106e9&scoped=true&"
import script from "./znpcYz.vue?vue&type=script&lang=js&"
export * from "./znpcYz.vue?vue&type=script&lang=js&"
import style0 from "./znpcYz.vue?vue&type=style&index=0&id=2ec106e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec106e9",
  null
  
)

export default component.exports